import '../Checkbox/Checkbox.scss';
import React from 'react';
import { Controller } from 'react-hook-form';

const ControlledCheckbox = ({
    name,
    control,
    text = '',
    reverseText = false,
    outerStyle,
    spanStyle,
    disabled = false,
    defaultValue = false,
    onCheckedChange,
    ...restProps
}) => {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field }) => (
                <div className={`Checkbox ${reverseText ? 'reversed' : ''}`} style={outerStyle}>
                    <label className={`Checkbox-Label ${disabled ? 'disabled' : ''}`}>
                        <input
                            type="checkbox"
                            checked={field.value}
                            onChange={(e) => {
                                const newValue = e.target.checked;
                                field.onChange(newValue);
                                if (onCheckedChange) {
                                    onCheckedChange(newValue);
                                }
                            }}
                            disabled={disabled}
                            {...restProps}
                        />
                        <span></span>
                    </label>
                    <div className={`Checkbox-Text ${disabled ? 'disabled' : ''}`}>
                        <span style={spanStyle}>{text}</span>
                    </div>
                </div>
            )}
        />
    );
};

export default ControlledCheckbox;
